
<footer class="footer pt-5 footer-bg  pb-5 shadow-lg" style="min-height: 300px;margin-top:200px;">
    <div class="container">
      <div class="row justify-content-md-center">
        <div class="col-md-3">
          <ul class="list-group list-group-flush">
            <li class="list-group-item footer-bg text-white"><h4>Navigation</h4></li>
            <li class="list-group-item footer-bg text-white">
                <a class="text-white" routerLink="/" routerLinkActive="active"><i class="fas fa-home"></i>&nbsp;Home</a>
              </li>
              <li class="list-group-item footer-bg text-white">
                <a class="text-white" routerLink="/how-it-works" routerLinkActive="active"><i class="fas fa-question-circle"></i>&nbsp;How it works</a>
              </li>
          </ul>
        </div>
        <div class="col-md-3">
            <ul class="list-group list-group-flush">
              <li class="list-group-item footer-bg text-white"><h4>External links</h4></li>
              <li class="list-group-item footer-bg text-white">
                  <a rel="noreferrer" class="text-white" href="https://www.cyberprotect.one" target="_blank"><i class="fas fa-globe-americas"></i>&nbsp;cyberprotect.one</a>
                </li>
                                <li class="list-group-item footer-bg text-white">
                    <a rel="noreferrer" class="text-white" href="https://www.linkedin.com/company/cyberprotect-sdn-international/" target="_blank"><i class="fab fa-linkedin"></i>&nbsp;Linkedin</a>
                  </li>
                <li class="list-group-item footer-bg text-white">
                  <a rel="noreferrer" class="text-white" href="https://twitter.com/@Cyberprotect" target="_blank"><i class="fab fa-twitter"></i>&nbsp;Twitter</a>
                </li>
                <li class="list-group-item footer-bg text-white">
                  <a rel="noreferrer" class="text-white" href="https://medium.com/@cyberprotect" target="_blank"><i class="fab fa-medium"></i>&nbsp;Medium</a>
                </li>
                <li class="list-group-item footer-bg text-white">
                    <a rel="noreferrer" class="text-white" href="https://github.com/Cyberprotect" target="_blank"><i class="fab fa-github"></i>&nbsp;Github</a>
                  </li>
            </ul>
          </div>
          <div class="col-md-6">
              <ul class="list-group list-group-flush">
                <li class="list-group-item footer-bg text-white"><h4>Contact</h4></li>
                <li class="list-group-item footer-bg text-white">
                    <span class="text-white"><i class="fas fa-map-marked-alt"></i>&nbsp;17 allée des Ginkgos, 69500 Bron - France</span>
                  </li>
                  <li class="list-group-item footer-bg text-white">
                    <span class="text-white"><i class="fas fa-phone"></i>&nbsp;+33 451 085 100‬</span>
                  </li>
                  <li class="list-group-item footer-bg text-white">
                    <span class="text-white"><i class="fas fa-envelope"></i>&nbsp;contact [at] cyberprotect [dot] one</span>
                  </li>
              </ul>
            </div>

      </div>
      <hr/>
      <div class="row align-items-center justify-content-md-center">
          <div class="col-md-6 text-center">
              <a rel="noreferrer" class="text-white" href="https://www.cyberprotect.one" target="_blank">
            <img src="https://assets.cyberprotect.cloud/LOGO_Cyberprotect-fondnoir.png" class="col-lg-12 my-5" alt="Cyberprotect">
            </a>

              <div class="copyright text-white mb-5">
                &copy; 2024 <span translate>Cyberprotect</span>
                <br/>
                <small class="text-white">NICKI - New Intelligence for Cyber-threat Knowledge Inter-connectivity</small>
              </div>

            </div>
      </div>

    </div>
  </footer>
